var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAddress = function SvgAddress(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 24,
    fill: "none",
    viewBox: "0 0 20 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M14.112 21.157c0 .325.257.589.588.589h2.925a.588.588 0 00.587-.58V10.913c0-.486-.282-1.163-.623-1.503L10.43 2.253a.59.59 0 00-.836 0L2.438 9.411c-.345.344-.623 1.012-.623 1.503v10.251c0 .321.256.581.587.581h2.925a.588.588 0 00.587-.59v-5.85c0-.971.786-1.758 1.759-1.758h4.681c.971 0 1.759.786 1.759 1.758v5.85zm-1.757-5.263a.589.589 0 00-.583-.59H8.255a.586.586 0 00-.584.59v5.85c0 .971-.787 1.759-1.756 1.759H1.814c-.97 0-1.756-.784-1.756-1.755V11.06c0-.969.556-2.311 1.24-2.995L8.772.59a1.755 1.755 0 012.482 0l7.474 7.474c.685.685 1.24 2.024 1.24 2.995v10.688c0 .969-.785 1.755-1.756 1.755h-4.1c-.97 0-1.757-.786-1.757-1.759v-5.85z"
  })));
};
export default SvgAddress;